<td>{{materialChoice.inventory.supplier_name}}</td>
<td>
  <div [ngbTooltip]="materialChoice.inventory.variation_id">
    {{materialChoice.inventory.article_name}}&nbsp;
    @if (materialChoice.inventory.variation.favorite) {
      <i class="fa fa-star star-yellow"
        ngbTooltip="bevorzugtes Material"
      ></i>
    }
  </div>
</td>
<td class="align-right">{{$safeNavigationMigration(materialChoice.inventory.variation?.vendor_price)|money:2}}</td>

@for (field of fields; track field) {
  <td [ngClass]="{'align-right': field.isValueType('Number')}">
    <material-field-value [field]="field" [fields]="materialChoice.inventory.fields">
    </material-field-value>
  </td>
}

<td class="align-right">
  <a ngbTooltip="Bestand im Materiallager"
    uiSref="a.material.inventory.update"
    target="_blank"
    [uiParams]="{variation: materialChoice.inventory.id}">
    {{materialChoice.inventory.amount|money}}
  </a>
</td>

@if (materialChoice.has_selected_date) {
  <td class="align-right">
    <a ngbTooltip="Unbestätigte Bestellungen aller BAs im ausgewählten Zeitraum"
      uiSref="a.material.inventory.update"
      target="_blank"
      [uiParams]="{variation: materialChoice.inventory.id}">
      <span class="label label-default">{{materialChoice.total_ordered_to_selected_date|money}}</span>
    </a>
  </td>
}
<td class="align-right">
  <a ngbTooltip="Unbestätigte Bestellungen Gesamt"
    uiSref="a.material.inventory.update"
    target="_blank"
    [uiParams]="{variation: materialChoice.inventory.id}">
    {{materialChoice.inventory.amount_ordered|money}}
  </a>
</td>

@if (materialChoice.has_selected_date) {
  <td class="align-right">
    <a ngbTooltip="Bestätigte Bestellungen aller BAs im ausgewählten Zeitraum"
      uiSref="a.material.inventory.update"
      target="_blank"
      [uiParams]="{variation: materialChoice.inventory.id}">
      <span class="label label-default">{{materialChoice.total_confirmed_to_selected_date|money}}</span>
    </a>
  </td>
}
<td class="align-right">
  <a ngbTooltip="Bestätigte Bestellungen Gesamt"
    uiSref="a.material.inventory.update"
    target="_blank"
    [uiParams]="{variation: materialChoice.inventory.id}">
    {{materialChoice.inventory.amount_confirmed|money}}
  </a>
</td>
<td class="align-right">
  <a ngbTooltip="Bestätigte überfällige Bestellungen Gesamt"
    uiSref="a.material.inventory.update"
    target="_blank"
    [uiParams]="{variation: materialChoice.inventory.id}">
    <div [class]="{'red-font': materialChoice.inventory.amount_confirmed_open > 0}">
      {{materialChoice.inventory.amount_confirmed_open|money}}
    </div>
  </a>
</td>

@if (materialChoice.has_selected_customer) {
  <td class="align-right">
    <a ngbTooltip="Planung für Kunde"
      uiSref="a.business_order.list"
      target="_blank"
      [uiParams]="linkParams">
      <span class="label" [ngClass]="{ 'label-info': !markRedCustomer, 'label-warning': markRedCustomer }">
        {{materialChoice.total_required_customer|money}}
      </span>
    </a>
  </td>
}
@if (materialChoice.has_selected_date) {
  <td class="align-right">
    <a ngbTooltip="Planung aller BAs im ausgewählten Zeitraum"
      uiSref="a.business_order.list"
      target="_blank"
      [uiParams]="linkParams">
      <span class="label" [ngClass]="{ 'label-default': !markOrangeToSelectedDate, 'label-warning': markOrangeToSelectedDate }">
        {{materialChoice.total_required_to_selected_date|money}}
      </span>
    </a>
  </td>
}
<td class="align-right">
  <a ngbTooltip="Planung Gesamt"
    uiSref="a.business_order.list"
    target="_blank"
    [uiParams]="{variation_id: materialChoice.inventory.id, status: 0}">
    <span [ngClass]="{'orange-cfa': markOrange && !markRed, 'label': markRed, 'label-danger': markRed}">
      {{materialChoice.inventory.amount_planned|money}}
    </span>
  </a>
</td>

<ng-template #weekTooltip let-week let-label="label">
  <div>{{ label }} {{ week.tooltip_description }}</div>
  @if (week.tooltip_lead_time) {
    <div>{{ week.tooltip_lead_time }}</div>
  }
</ng-template>

@for (week of weeksWithColors; track week.first_day_of_week) {
  <td class="align-right cursor-pointer vertical-black-border-left p-0! content-center"
      [ngClass]="week.class_left"
      (click)="setSelectedWeek(week)">
    <div class="inline w-full p-2"
         [ngbTooltip]="weekTooltip"
         [tooltipContext]="{ $implicit: week, label: 'Bestätigt' }"
         tooltipClass="tooltip-min-300">
      {{ week.confirmed|money }}
    </div>
  </td>
  <td class="align-right cursor-pointer p-0! content-center"
      [ngClass]="week.class_right"
      (click)="setSelectedWeek(week)">
    <div class="inline w-full p-2"
         [ngbTooltip]="weekTooltip"
         [tooltipContext]="{ $implicit: week, label: 'Geplant' }"
         tooltipClass="tooltip-min-300">
      {{ week.required|money }}
    </div>
  </td>
}

<td>
  <a uiSref="a.material.order.create"
    target="_blank"
    [ngbTooltip]="'Material ' + materialChoice.inventory.variation.variation_id + ' ' + materialChoice.inventory.variation.article.name + ' Bestellen'"
    [uiParams]="{supplier_id: materialChoice.inventory.supplier_id, marked_variation_id: materialChoice.inventory.id}">
    <i class="fa fa-truck"></i>
  </a>
</td>
